<div class="quick-search">
  <aa-quick-search-word
    [storageKey]="'/admin/impersonate/popin/user'"
    (qsWordChanged)="onQsWordChanged($event)"
  ></aa-quick-search-word>
</div>
@if (isEmpty | async) {
  <div class="multi-zone"
    >
    <aa-lack-of-data [title]="'ADMIN.LIST.LACKOFDATA.TITLE' | translate"
      [message]="">
    </aa-lack-of-data>
  </div>
}
@if (!(isEmpty | async)) {
  <div class="multi-zone"
    >
    <div class="virtual-scrollable-viewport aa-scrollable-y aa-scrollbar">
      @for (user of users | async; track user; let idx = $index) {
        <aa-user-card
          [user]="user"
          [withRoles]="true"
          [cta]="onSelect"
          [impePopin]="true"
          >
        </aa-user-card>
      }
    </div>
  </div>
}